import { apiSlice } from "../api/apiSlice";

export const dialogsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDialogs: builder.query({
      query: () => `/my/dialogs`,
      providesTags: (result, error, arg) => [{ type: "Dialog" }],
    }),
    getDialog: builder.query({
      query: ({ dialogId, from = 0 }) => `/my/dialogs/${dialogId}?from=${from}`,
      providesTags: (result, error, arg) => [
        { type: "Dialog", id: `${arg?.dialogId}-${arg?.from}` },
      ],
    }),
    postDialog: builder.mutation({
      query: ({ body }) => {
        return {
          url: `/my/dialogs`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "Dialog" }],
    }),
    postMessage: builder.mutation({
      query: ({ params, body }) => {
        return {
          url: `/my/dialogs/${params?.dialogId}/messages`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, arg) => [
        { type: "Message" },
        {
          type: "Message",
          id: `${arg?.params?.dialogId}`,
        },
      ],
    }),
  }),
});

export const {
  useGetDialogsQuery,
  useGetDialogQuery,
  usePostDialogMutation,
  usePostMessageMutation,
} = dialogsSlice;
